module.exports = __webpack_public_path__ + "img/PPT版_00.ba59fe99.png";